module.exports = __webpack_public_path__ + "img/video-camera.d06173b8.svg";